import {
	Grid2,
	IconButton,
	Paper,
	Skeleton,
	styled,
	Table,
	TableBody,
	TableCell,
	tableCellClasses,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
} from '@mui/material';
import { useMainCustomStyle } from '../assets/theme/Theme';
import SideNavigationBar from '../components/SideNavigationBar';
import { useEffect, useState } from 'react';
import {
	ChatData,
	ChatHistoryList,
	ChatHistoryResponse,
	Chats,
	ChatsResponse,
} from '../types';
import { fetchChatHistoryList, fetchChatHistory } from '../services/ApiService';
import _ from 'lodash';
import { convertTo12HourTime, dateFormatter } from '../Utils/Helpers';
import { EyeIcon } from '../assets/icons/Icons';
import ChatPopup from '../components/ChatPopup';

function ChatHistory() {
	const mainDivStyle = useMainCustomStyle();
	const [chatHistoryList, setChatHistoryList] = useState<
		Array<ChatHistoryList>
	>([]);
	const [rowsPerPage, setRowsPerPage] = useState(15);
	const [page, setPage] = useState(0);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [popupTitle, setPopupTitle] = useState('');
	const [selectedChatData, setSelectedChatData] = useState<Array<ChatData>>(
		[],
	);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		getChatHistoryList();
	}, []);

	async function getChatHistoryList() {
		setIsLoading(true);
		const data: Array<ChatHistoryResponse> = await fetchChatHistoryList();
		const orderByTime = _.orderBy(data, 'timestamp', 'desc');

		const sortedData: Array<ChatHistoryList> = orderByTime.map(item => {
			const convertTime = convertTo12HourTime(
				item.timestamp.split(' ')[1],
			);
			const value: ChatHistoryList = {
				messageDate: dateFormatter(item.timestamp.split(' ')[0]),
				messageTime: convertTime,
				user_id: item.user_id,
			};

			return value;
		});

		setChatHistoryList(sortedData);
		setIsLoading(false);
	}

	const handleChangePage = (
		event: React.MouseEvent<HTMLButtonElement> | null,
		newPage: number,
	) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	async function onViewChats(id: string) {
		setPopupTitle(id);

		const data: ChatsResponse = await fetchChatHistory(id);

		const updatedData: Array<ChatData> = [];

		console.log(Array.isArray(data.payload));

		data.payload.map((item, index) => {
			updatedData.push({
				text: item,
				date: '',
				time: '',
				type: index % 2 !== 0 ? 'ai' : 'human',
			});
			// Object.keys(item).map(value => {
			// 	updatedData.push({
			// 		text: value,
			// 		date: '',
			// 		time: '',
			// 		type: value === 'bot_response' ? 'ai' : 'human',
			// 	});
			// });
		});

		setSelectedChatData(updatedData);
		setIsModalOpen(true);
	}

	function onCloseModal() {
		setIsModalOpen(false);
		setSelectedChatData([]);
		setPopupTitle('');
	}

	return (
		<>
			<SideNavigationBar />
			<div style={mainDivStyle}>
				<Grid2 container paddingLeft={'20px'} paddingRight={'20px'}>
					<Grid2
						container
						sx={{ paddingLeft: '10px', width: '100%' }}>
						<TableContainer
							component={Paper}
							style={{
								boxShadow: 'none',
							}}>
							<Table
								sx={{ minWidth: 700, width: '100%' }}
								aria-label="customized table">
								<TableHead>
									<TableRow>
										<StyledTableCell align="center">
											<TableHeaderText>
												User
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												Date
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												Time
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												View Chat
											</TableHeaderText>
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{isLoading ? (
										<StyledTableRow>
											{[...Array(4)].map((_, index) => (
												<StyledTableCell
													key={index}
													align="center">
													<Skeleton
														animation="wave"
														style={{
															borderRadius: '5px',
														}}
														variant="rounded"
													/>
												</StyledTableCell>
											))}
										</StyledTableRow>
									) : chatHistoryList &&
									  chatHistoryList.length > 0 ? (
										chatHistoryList
											.slice(
												page * rowsPerPage,
												page * rowsPerPage +
													rowsPerPage,
											)
											.map((chat, index) => {
												return (
													<StyledTableRow key={index}>
														<StyledTableCell align="center">
															<TableRowText>
																{chat.user_id}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{
																	chat.messageDate
																}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{
																	chat.messageTime
																}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<IconButton
																sx={{
																	padding:
																		'0px',
																}}
																onClick={() =>
																	onViewChats(
																		chat.user_id,
																	)
																}>
																<EyeIcon />
															</IconButton>
														</StyledTableCell>
													</StyledTableRow>
												);
											})
									) : (
										<StyledTableRow>
											<StyledTableCell
												colSpan={4}
												align="center">
												<TableRowText>
													No data available
												</TableRowText>
											</StyledTableCell>
										</StyledTableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={[]}
							component="div"
							count={chatHistoryList && chatHistoryList.length}
							rowsPerPage={rowsPerPage}
							page={page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
						/>
					</Grid2>
				</Grid2>
			</div>
			<ChatPopup
				data={selectedChatData}
				isModalOpen={isModalOpen}
				popupTitle={popupTitle}
				onClose={onCloseModal}
				isChatView={
					selectedChatData && Object.keys(selectedChatData).length > 0
				}
			/>
		</>
	);
}

export const StyledTableCell = styled(TableCell)(() => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: '#FFFFFF',
		color: 'rgba(0, 0, 0, 0.5)',
		paddingTop: '20px',
		fontSize: 12,
		fontWeight: 600,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 12,
		fontWeight: 400,
		color: '#000000',
		maxWidth: 80,
	},
}));

export const StyledTableRow = styled(TableRow)(() => ({
	'&:nth-of-type(odd)': {
		background:
			'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #C2C9D1',
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
}));

export const TableHeaderText = styled(Typography)(() => ({
	fontSize: '12px',
	fontWeight: '600',
	color: 'rgba(0, 0, 0, 0.5)',
}));

export const TableRowText = styled(Typography)(() => ({
	fontSize: '12px',
	fontWeight: '400',
	color: 'rgba(0, 0, 0, 1)',
}));

export default ChatHistory;
